<template>
    <div class="tw-mb-5 tw-aspect-[16/10] tw-w-full tw-rounded-[10px] tw-bg-gray-300"></div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
